module.exports = __webpack_public_path__ + "img/logo.528fe3f9.png";